export const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
  
      // Find the next focusable element
      const nextElement = getNextFocusableElement(e.target);
      if (nextElement) {
        // Focus on the next element
        nextElement.focus();
      }
    }
  };
  
  const getNextFocusableElement = (currentElement) => {
    // Query all focusable elements
    const focusableElements = document.querySelectorAll(
      'input:not([readonly]), select:not([readonly]), textarea:not([readonly]), button:not([disabled]), [tabindex]:not([tabindex="-1"]), a[href], .MuiAutocomplete-input, .MuiPickersBasePicker-pickerView'
    );
  
    // Convert NodeList to Array and filter out read-only elements
    const filteredFocusableElements = Array.from(focusableElements).filter((element) => !element.readOnly);
  
    // Find the current element's index
    const currentIndex = filteredFocusableElements.indexOf(currentElement);
  
    // Return the next focusable element if it exists, otherwise null
    return filteredFocusableElements[currentIndex + 1] || null;
  };